import { useRef } from "react";
import { useSelector } from "react-redux";

import "./styles.scss";

const iframeUrl = "https://icool-kho-statistic.vercel.app/";
// const iframeUrl = "http://localhost:3334/";

const DashboardPage = () => {
  //#region Data
  const iframeRef = useRef(null);
  const auth = useSelector((state) => state.auth);

  const sendTokenToIframe = () => {
    iframeRef.current?.contentWindow?.postMessage(
      { type: "AUTH_TOKEN", token: auth?.token },
      iframeUrl,
    );
  };
  //#endregion

  //#region Render
  return (
    <iframe
      ref={iframeRef}
      src={iframeUrl}
      width="100%"
      onLoad={sendTokenToIframe}
      style={{ border: "none", height: "80vh" }}
    ></iframe>
  );
  //#endregion
};
export default DashboardPage;
